import React from "react";

function MapPinIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="21"
      fill="none"
      viewBox="0 0 16 21"
    >
      <path
        fill="currentColor"
        d="M8 .792c-4.41 0-8 3.59-8 7.995-.029 6.445 7.696 11.79 8 12.005 0 0 8.03-5.56 8-12 0-4.41-3.589-8-8-8zm0 12c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
      ></path>
    </svg>
  );
}

export default MapPinIcon;
